import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import {App} from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, HashRouter} from 'react-router-dom';
import {SignInContextProvider} from "./context/SignInContext";
import {Provider as AppProvider} from "./context/AppContext";
import "./assets/css/overview.css"
import {WebSettingsContextProvider} from "./context/WebSettingsContext";
import isElectron from "./utils/functions";

const Router = isElectron() ? BrowserRouter : BrowserRouter;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Router>
            <SignInContextProvider>
              <WebSettingsContextProvider>
                <AppProvider >
                  <App/>
                </AppProvider>
              </WebSettingsContextProvider>
            </SignInContextProvider>
        </Router>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
